import { FC, PropsWithChildren } from 'react'

import { Text, View } from '@react-pdf/renderer'

interface Props {
  flex?: number
  textAlign?: 'left' | 'center' | 'right'
  highlighted?: boolean
}

const Cell: FC<PropsWithChildren<Props>> = ({ children, flex = 1, highlighted, textAlign }) => (
  <View
    style={{
      fontWeight: highlighted ? 'bold' : 'medium',
      padding: 16,
      flex,
      textAlign,
    }}
  >
    <Text style={{ fontSize: 10, color: highlighted ? '#1E1E31' : '#515164' }}>{children}</Text>
  </View>
)

export default Cell
